import React, {useEffect, useRef, useState} from 'react';
import { connect } from 'react-redux';

import {withRouter} from "react-router-dom";
import Button from "../../ui/components/buttons/button";
import {_getPolicy, _storePolicy} from "../../store/policy/service";
import Template from "../template/template";
import FormTextField from "../../ui/components/form-controls/form-text-field";
import FormDateField from "../../ui/components/form-controls/form-date-field";
import LabelledCheckbox from "../../ui/components/form-controls/labelled-checkbox";
import AddressDropdown from "../address-dropdowns";
import RadioBox from "../radio-box";
import {useTranslation} from "react-i18next";
import {Formik, Form, Field} from "formik";
import * as yup from "yup";

import "./uen.css";
import {
    _getStep,
    _hideSpinner,
    _showSpinner,
    _showModal,
    _hideModal,
    _setStep, _getSite
} from "../../store/system/service";
import WarningIcon from "../../assets/Warning.svg";
import QuoteBannerLogo from "../../assets/QuoteBanner.png";
import TitleBox from "../title-box";
import moment from "moment";
import {
    _saveForLater,
    _scrollToComponent,
    _initYum,
    _gaPushEvent,
    _gaPushData,
    _getOccupationDesc
} from "../../utils/utility";

const Uen = (props) => {
    const { t } = useTranslation();
    const uenAvailabilityOptions = [
        {
            label: 'Yes',
            value: 'true'
        },
        {
            label: 'No',
            value: 'false'
        }
    ];

    useEffect(() => {
        window.scrollTo(0, 0);
        props.setStep(2);
    }, []);

    const bottomCompRef = useRef(null);
    const topCompRef = useRef(null);
    const middleCompRef = useRef(null);
    const altBottomCompRef = useRef(null);
    const correspondingAddressRef = useRef(null);
    const companyNameRef = useRef(null);

    const [showBusinessAddress, setShowBusinessAddress] = useState(false)
    const [showCorrespondingAddress, setCorrespondingAddress] = useState(false)
    const continueNextPage = (values, setSubmitting) => {
        _gaPushEvent('ApplyContinue');
        if(!values.companyName){
            showPopup();
            return;
        }

        props.policy.policySME.insuredPerson = values.insuredName.toUpperCase();
        props.policy.policySME.locationPostCode = values.postcode;
        props.policy.policySME.locationAccumulationRegister = values.accumulationReg;
        props.policy.policySME.locationAddress1 = values.street.toUpperCase();
        props.policy.policySME.locationUnitNo = values.unit.toUpperCase();
        props.policy.policySME.locationFloorNo = values.floor.toUpperCase();
        props.policy.policySME.locationBuildingName = values.building.toUpperCase();
        props.policy.policySME.occupationDesc = values.businessDesc.toUpperCase();
        props.policy.policySME.applicant.uen = values.uen;
        props.policy.policySME.applicant.fullName = values.companyName;
        props.policy.policySME.applicant.sameAsInsuredAddress = values.sameAsInsuredAddress;

        if (values.sameAsInsuredAddress) {
            props.policy.policySME.applicant.applicantPostCode = props.policy.policySME.locationPostCode;
            props.policy.policySME.applicant.applicantAddress1 = props.policy.policySME.locationAddress1;
            props.policy.policySME.applicant.applicantUnitNo = props.policy.policySME.locationUnitNo;
            props.policy.policySME.applicant.applicantFloorNo = props.policy.policySME.locationFloorNo;
            props.policy.policySME.applicant.applicantBuildingName = props.policy.policySME.locationBuildingName;
        }
        else {
            props.policy.policySME.applicant.applicantPostCode = values.corresPostcode;
            props.policy.policySME.applicant.applicantAddress1 = values.corresStreet.toUpperCase();
            props.policy.policySME.applicant.applicantUnitNo = values.corresUnit.toUpperCase();
            props.policy.policySME.applicant.applicantFloorNo = values.corresFloor.toUpperCase();
            props.policy.policySME.applicant.applicantBuildingName = values.corresBuilding.toUpperCase();
        }

        if (values.effectiveDate) {
            if(!props.policy.policySME.inceptionDate){
                _gaPushEvent('applyedit');
            }

            props.policy.policySME.inceptionDate = moment(values.effectiveDate).format('DD/MM/YYYY');
            // set expiry date
            props.policy.policySME.expiryDate = moment(values.effectiveDate).add(1, 'years').subtract(1, 'days').format('DD/MM/YYYY');
        }
        else {
            props.policy.policySME.inceptionDate = '';
            props.policy.policySME.expiryDate = '';
        }

        if (values.dob) {
            props.policy.policySME.insuredPersonBirthDate = moment(values.dob).format('DD/MM/YYYY');
        }

        props.storePolicy(props.policy);
        setSubmitting(false);
        props.history.push((props.site ? '/' + props.site : '') + '/application');
    }

    const showPopup = () => {
        _gaPushData({
            'pageStep': 'UENnotFound',
            'vPath': '/uennotfound',
            'event': 'vpageview'
        });
        props.showModal(
            {
                icon: WarningIcon,
                title: 'We still can’t find the UEN number, do you need help?',
                content:
                    <div className="UenNotFoundPopupContent">
                        You may save this quote and come back later <br/>
                        or search your UEN number
                    </div>,
                primaryAction: {
                    label: 'Search UEN number',
                    onClick: () => {
                        props.hideModal();
                        searchUenNumberClick("true");
                    }
                },
                secondaryAction: {
                    label: 'Save this form',
                    onClick: () => {
                        props.hideModal();
                        saveThisFormClick("true");
                    }
                }
            }
        )
    }

    const saveThisFormClick = (noUen) => {
        if (noUen == "true") {
            _gaPushEvent('UENnotFoundSavethisform');
        } else {
            _gaPushEvent('applysaveforlater');
        }

        props.saveForLater(props, "false");
    }

    const searchUenNumberClick = (noUen) => {
        if (noUen == "true") {
            _gaPushEvent('UENnotFoundSearchUEN');
        } else {
            _gaPushEvent('searchUENnumber');
        }

        window.open(process.env.REACT_APP_UEN_SEARCH_SITE_URL, '_blank');
    }

    /* Validation - Start */
    _initYum(yup);
    const validationSchema = yup.object().shape({
        uen: yup.string()
            .required(() => {
                if(window.innerWidth>768) {
                    _scrollToComponent(topCompRef);
                }
                return t('uen.validationMessage.required');
            }),
        companyName: yup.string()
            .required(() => {
                if(window.innerWidth>768) {
                    _scrollToComponent(topCompRef);
                }
                return t('companyName.validationMessage.required');
            }),
        businessDesc: yup.string()
            .required(() => {
                if(window.innerWidth>768) {
                    _scrollToComponent(topCompRef);
                }
                return t('businessDesc.validationMessage.required');
            }),
        postcode: yup.string()
            .required(() => {
                return t('address.postcode.validationMessage.required');
            })
            .min(6,'6-digits postal code is required.')
            .matches(/^[a-zA-Z0-9-#&.',/() ]*$/g, t('address.postcode.validationMessage.pattern'))
            .address(t('address.common', { returnObjects: true})),
        street: yup.string()
            .required(() => {
                return t('address.street.validationMessage.required');
            })
            .matches(/^[a-zA-Z0-9-#&.',/() ]*$/g, t('address.street.validationMessage.pattern'))
            .address(t('address.common', { returnObjects: true})),
        floor: yup.string()
            .matches(/^[a-zA-Z0-9-#&.',/() ]*$/g, () => {
                if(window.innerWidth>768) {
                    _scrollToComponent(middleCompRef);
                }
                return t('address.floor.validationMessage.pattern')
            }),
        unit: yup.string()
            .matches(/^[a-zA-Z0-9-#&.',/() ]*$/g, () => {
                if(window.innerWidth>768) {
                    _scrollToComponent(middleCompRef);
                }
                return t('address.unit.validationMessage.pattern')
            }),
        building: yup.string()
            .matches(/^[a-zA-Z0-9-#&.',/() ]*$/g, () => {
                if(window.innerWidth>768) {
                    _scrollToComponent(middleCompRef);
                }
                return t('address.buildingName.validationMessage.pattern')
            }),
        sameAsInsuredAddress: yup.boolean(),
        corresPostcode: yup.string()
            .min(6,'6-digits postal code is required.')
            .matches(/^[a-zA-Z0-9-#&.',/() ]*$/g, t('address.postcode.validationMessage.pattern'), () => {
                if(window.innerWidth>768) {
                    _scrollToComponent(altBottomCompRef);
                }
            })
            .when('sameAsInsuredAddress', {
                is: false,
                then: yup.string().required(() => {
                    return t('address.postcode.validationMessage.required');
                }).address(t('address.common', { returnObjects: true}))
            }),
        corresStreet: yup.string()
            .matches(/^[a-zA-Z0-9-#&.',/() ]*$/g, t('address.street.validationMessage.pattern'), () => {
                if(window.innerWidth>768) {
                    _scrollToComponent(altBottomCompRef);
                }
            })
            .when('sameAsInsuredAddress', {
                is: false,
                then: yup.string().required(() => {
                    return t('address.street.validationMessage.required');
                }).address(t('address.common', { returnObjects: true}))
            }),
        corresFloor: yup.string()
            .matches(/^[a-zA-Z0-9-#&.',/() ]*$/g, t('address.floor.validationMessage.pattern'), () => {
                if(window.innerWidth>768) {
                    _scrollToComponent(altBottomCompRef);
                }
            }),
        corresUnit: yup.string()
            .matches(/^[a-zA-Z0-9-#&.',/() ]*$/g, t('address.floor.validationMessage.pattern'), () => {
                if(window.innerWidth>768) {
                    _scrollToComponent(altBottomCompRef);
                }
            }),
        corresBuilding: yup.string()
            .matches(/^[a-zA-Z0-9-#&.',/() ]*$/g, t('address.floor.validationMessage.pattern'), () => {
                if(window.innerWidth>768) {
                    _scrollToComponent(altBottomCompRef);
                }
            }),
        insuredName: yup.string()
            .required(() => {
                return t('insuredName.validationMessage.required');
            }),
        dob: yup.date()
            .typeError(t('dob.validationMessage.type'))
            .min(moment().endOf('day').add("year", -66), () => {
                if(window.innerWidth>768) {
                    _scrollToComponent(bottomCompRef);
                }
                return t('dob.validationMessage.min');
            })
            .max(moment().endOf('day').add("year", -18), () => {
                if(window.innerWidth>768) {
                    _scrollToComponent(bottomCompRef);
                }
                return t('dob.validationMessage.max');
            })
            .required(() => {
                if(window.innerWidth>768) {
                    _scrollToComponent(bottomCompRef);
                }
                return t('dob.validationMessage.required');
            }).nullable(),
        effectiveDate: yup.date()
            .typeError(t('effectiveDate.validationMessage.type'))
            .min(moment().startOf('day'), () => {
                if(window.innerWidth>768) {
                    _scrollToComponent(topCompRef);
                }
                return t('effectiveDate.validationMessage.min');
            })
            .max(moment().add('day', 90), () => {
                if(window.innerWidth>768) {
                    _scrollToComponent(topCompRef);
                }
                return t('effectiveDate.validationMessage.max');
            })
            .required(() => {
                if(window.innerWidth>768) {
                    _scrollToComponent(topCompRef);
                }
                return t('effectiveDate.validationMessage.required');
            }).nullable()
    });
    /* Validation - End */

    const initialValues = {
        uen: props.policy.policySME.applicant.uen || "",
        companyName: props.policy.policySME.applicant.fullName || "",
        insuredName: props.policy.policySME.insuredPerson === "dummy" ? "" : props.policy.policySME.insuredPerson || "",
        dob: props.policy.policySME.insuredPersonBirthDate ? moment(props.policy.policySME.insuredPersonBirthDate, 'DD/MM/YYYY') : moment("01/01/1980", 'DD/MM/YYYY'),
        postcode: props.policy.policySME.locationAddress1 && props.policy.policySME.locationAddress1 !==  "dummy" ? props.policy.policySME.locationPostCode : "",
        street: props.policy.policySME.locationAddress1 && props.policy.policySME.locationAddress1 !==  "dummy" ? props.policy.policySME.locationAddress1 : "",
        floor: props.policy.policySME.locationFloorNo|| "",
        unit: props.policy.policySME.locationUnitNo || "",
        building: props.policy.policySME.locationBuildingName || "",
        effectiveDate: props.policy.policySME.inceptionDate ? moment(props.policy.policySME.inceptionDate, 'DD/MM/YYYY') : moment(),
        uenAvailable: props.policy.policySME.applicant.fullName ? "true" : "",
        sameAsInsuredAddress: props.policy.policySME.applicant.sameAsInsuredAddress,
        businessDesc: props.policy.policySME.occupationDesc,
        corresPostcode: props.policy.policySME.applicant.sameAsInsuredAddress ?  props.policy.policySME.locationPostCode : props.policy.policySME.applicant.applicantPostCode || "",
        corresStreet: props.policy.policySME.applicant.sameAsInsuredAddress ?  props.policy.policySME.locationAddress1 : props.policy.policySME.applicant.applicantAddress1 || "",
        corresUnit: props.policy.policySME.applicant.sameAsInsuredAddress ?  props.policy.policySME.locationUnitNo : props.policy.policySME.applicant.applicantUnitNo || "",
        corresBuilding: props.policy.policySME.applicant.sameAsInsuredAddress ?  props.policy.policySME.locationBuildingName : props.policy.policySME.applicant.applicantBuildingName || "",
        corresFloor: props.policy.policySME.applicant.sameAsInsuredAddress ?  props.policy.policySME.locationFloorNo : props.policy.policySME.applicant.applicantFloorNo || "",
        uenChanged: props.policy.policySME.applicant.fullName ? "false" : '',
        accumulationReg: props.policy.policySME.locationAccumulationRegister || ""
    }

    // Google Analytics
    useEffect(() => {
        _gaPushData({
            'pageStep': 'apply',
            'vPath': '/apply',
            'event': 'vpageview',
            'ecommerce': {
                'checkout': {
                    'actionField': { 
                        'step': '3', 
                        'option': _getOccupationDesc(props.policy.policySME.occupationCode)
                    }	
                }
            }
        });
    }, [])


    return (
        <Template simple="Application" leftNav step={props.step} policy={props.policy} site={props.site} prevPage="/quote/summary">
            <Formik 
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values, {setSubmitting}) => {
                    setSubmitting(true);
                    continueNextPage(values, setSubmitting);
                }}>
                {({values, errors, touched, handleChange, handleBlur}) => (
                    <Form>
                        <img className="QuoteUenLogoStyle" src={QuoteBannerLogo} />
                        <div className="QuoteUenContainer">
                        <div className="UenInputGroupsStyle UenInputGroupTopStyle"  ref={topCompRef}>
                            <TitleBox>When would you like to have your policy effective?</TitleBox>
                            <div className="UenInputGroupStyle UenInputTopStyle">
                                <div className="UenInputBoxStyle">
                                    <Field
                                        id="effectiveDate"
                                        name="effectiveDate"
                                        label="Select Effective Date"
                                        as={FormDateField}
                                        disableToolbar
                                        errorMessage={errors.effectiveDate ? errors.effectiveDate : ""}
                                        minDate={moment().startOf('day')}
                                        maxDate={moment().add('day', 90)}
                                        onBlur={(event) => {
                                            if(!event.target.value){
                                                handleChange({ target: {
                                                    type: "change",
                                                    value: initialValues.effectiveDate,
                                                    name: "effectiveDate"
                                                }});
                                            } else {
                                                handleBlur(event)
                                            }
                                        }}
                                        onChange={(date) => {
                                            handleChange({ target: {
                                                type: "change",
                                                value: date,
                                                name: "effectiveDate"
                                            }});
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        { values.effectiveDate && (
                        <React.Fragment>
                        <TitleBox>Do you have your UEN ready?</TitleBox>
                        <div className="UenInputGroupsStyle UenRadioBoxStyle">
                            <Field
                                name="uenAvailable"
                                options={uenAvailabilityOptions}
                                as={RadioBox}
                            />
                            {values.uenAvailable !=="true"&&values.uenAvailable!=="false"?(<div className="UenInputGroupStyleMobileBuffer"></div>):null}
                        </div>
                        <div className="UenInputGroupsStyle">
                            { (values.uenAvailable === "true" || values.uenAvailable === "verified") && (
                            <React.Fragment>
                            <div className="UenInputGroupStyle">
                                <div className="UenInputBoxStyle UenInputUenStyle">
                                    <Field
                                        name="uen"
                                        label="UEN Number"
                                        errorMessage={touched.uen && errors.uen ? errors.uen : ''}
                                        onBlur={(event) => {
                                            handleBlur(event);
                                        }}
                                        onChange={(event) => {
                                            handleChange(event);
                                            handleChange({
                                                target: {
                                                    type: "change",
                                                    value: "true",
                                                    name: "uenChanged"
                                                }
                                            });
                                        }}
                                        as={FormTextField}
                                    />
                                </div>
                            </div>
                            </React.Fragment>
                            )}

                            { values.uenAvailable === "false" && (
                            <React.Fragment>
                            <div className="UenInputGroupsStyle">
                                <div className="QuoteUenMessaegGroupStyle">
                                    <div className="QuoteUenMessaegStyle">
                                        No worries, you can save for later or search your UEN at Singapore government agency website.
                                    </div>
                                </div>
                            </div>
                            <div className="UenInputGroupsStyle">
                                <div className="UenInputButtonsGroupStyle UenInputButtonsSaveStyle">
                                    <div className="UenInputButtonsStyle">
                                        <Button color="secondary" onClick={saveThisFormClick}>Save for later</Button>
                                        <Button color="primary" onClick={searchUenNumberClick}>Search UEN number</Button>
                                    </div>
                                </div>
                                <div className="UenBufferStyle"/>
                            </div>
                            </React.Fragment>
                            )}
                            { (values.uenAvailable === "true") && (
                            <div className="UenInputGroupsStyle UenCompanyNameStyle"  ref={companyNameRef}>
                                <div className="UenInputGroupStyle">
                                    <div className="UenInputBoxStyle">
                                        <Field
                                            label="Company Name"
                                            name="companyName" 
                                            errorMessage={errors.companyName}
                                            errorMessage={touched.companyName && errors.companyName ? errors.companyName :''}
                                            as={FormTextField}
                                        />
                                    </div>
                                </div>
                                <div className="UenInputGroupStyle">
                                    <div className="UenInputBoxStyle Caps">
                                        <Field
                                            label="Business Description"
                                            name="businessDesc" 
                                            errorMessage={touched.businessDesc && errors.businessDesc ? errors.businessDesc :''}
                                            as={FormTextField}
                                        />
                                    </div>
                                </div>
                            </div>
                            )}
                        </div>
                        </React.Fragment>
                        )}
                        {(values.uenAvailable === "true") && (
                        <React.Fragment>
                        <div className="QuoteUenSubTitleGroupStyle" >
                            <div className="QuoteUenSubTitleStyle">Insured Business Address</div>
                        </div>
                        <div className="UenInputGroupsStyle" ref={middleCompRef}>
                            <div className="UenInputGroupStyle" style={{'flex-direction':'column', minHeight:154,height: "auto"}}>
                                <div className="UenInputBoxStyle">
                                    <Field
                                        label="Postal Code"
                                        name="postcode"
                                        as={AddressDropdown}
                                        inputMode={'numeric'}
                                        errorMessage={touched.postcode && errors.postcode ? errors.postcode : ''}
                                        onMatched={(address, setSelectedValue) => {
                                            setSelectedValue(address.postCode);
                                            values.postcode = address.postCode;
                                            values.accumulationReg = address.accumulationRegister;
                                            handleChange({ target: {
                                                    type: "change",
                                                    value: address.streetName,
                                                    name: "street"
                                                }});
                                        }}
                                        showDetail={setShowBusinessAddress}
                                        onReset={( setSelectedValue)=>{
                                            setSelectedValue('');
                                            values.postcode = '';
                                            values.accumulationReg = '';
                                            handleChange({ target: {
                                                    type: "change",
                                                    value: '',
                                                    name: "street"
                                                }});
                                            handleChange({ target: {
                                                    type: "change",
                                                    value: '',
                                                    name: "unit"
                                                }});
                                            handleChange({ target: {
                                                    type: "change",
                                                    value: '',
                                                    name: "floor"
                                                }});
                                            handleChange({ target: {
                                                    type: "change",
                                                    value: '',
                                                    name: "building"
                                                }});
                                            setShowBusinessAddress(false)
                                        }}
                                        onChange={(value)=>{
                                            handleChange({ target: {
                                                    type: "change",
                                                    value: value,
                                                    name: "postcode"
                                                }});
                                        }}
                                        onClick={(address, setSelectedValue) => {
                                            setSelectedValue(address.postCode);
                                            values.postcode = address.postCode;
                                            values.accumulationReg = address.accumulationRegister;
                                            handleChange({ target: {
                                                type: "change",
                                                value: address.streetName,
                                                name: "street"
                                            }});
                                        }}
                                    />
                                </div>
                            </div>
                            {
                                showBusinessAddress&&
                                <>
                                    <div className="UenInputGroupStyle">
                                        <div className="UenInputBoxStyle Caps">
                                            <Field
                                                label="Street"
                                                name="street"
                                                as={FormTextField}
                                                errorMessage={touched.street && errors.street ? errors.street :''}
                                            />
                                        </div>
                                    </div>
                                    <div className="UenInputGroupStyle FloorUnit">
                                        <div className="UenInputBoxStyle">
                                            <div className="FloorUnitContainer">
                                                <div className={"FloorUnitHashSign"}>#</div>
                                                <div className="UenInputGroupStyle">
                                                    <div className="UenInputBoxStyle Caps">
                                                        <Field
                                                            label="Floor"
                                                            name="floor"
                                                            as={FormTextField}
                                                            errorMessage={touched.floor && errors.floor ? errors.floor : ''}
                                                        />
                                                    </div>
                                                </div>
                                                <div className={"FloorUnitDashSign"}> - </div>
                                                <div className="UenInputGroupStyle">
                                                    <div className="UenInputBoxStyle Caps">
                                                        <Field
                                                            label="Unit"
                                                            name="unit"
                                                            as={FormTextField}
                                                            errorMessage={touched.unit && errors.unit ? errors.unit : ''}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="UenInputGroupStyle">
                                        <div className="UenInputBoxStyle Caps">
                                            <Field
                                                label="Building"
                                                name="building"
                                                as={FormTextField}
                                                errorMessage={touched.building && errors.building ? errors.building : ''}
                                            />
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                        <div className="UenInputGroupStyle" ref={correspondingAddressRef}>
                            <div className="UenInputTopBoxStyle">
                            <Field
                                className="UenInputLabelLeftAlign"
                                label="The corresponding address is the same as the insured address"
                                name="sameAsInsuredAddress"
                                checked={values.sameAsInsuredAddress}
                                as={LabelledCheckbox}
                                onClick={(event) => {
                                    if(!event.target.checked){
                                        values.corresPostcode = "";
                                        values.corresStreet = "";
                                        values.corresUnit = "";
                                        values.corresFloor = "";
                                        values.corresBuilding = "";
                                    }
                                }}
                            />
                            </div>
                        </div>
                        { !values.sameAsInsuredAddress &&
                        <div className="UenInputGroupsStyle" ref={altBottomCompRef}>
                            <div className="QuoteUenSubTitleGroupStyle">
                                <div className="QuoteUenSubTitleStyle">Corresponding Address</div>
                            </div>
                            <div className="UenInputGroupStyle" style={{'flex-direction':'column', minHeight:154,height: "auto"}}>
                                <div className="UenInputBoxStyle">
                                    <Field
                                        label="Postal Code"
                                        name="corresPostcode"
                                        as={AddressDropdown}
                                        inputMode={'numeric'}
                                        errorMessage={touched.corresPostcode && errors.corresPostcode ? errors.corresPostcode : ''}
                                        onMatched={(address, setSelectedValue) => {
                                            setSelectedValue(address.postCode);
                                            values.corresPostcode = address.postCode;
                                            handleChange({ target: {
                                                    type: "change",
                                                    value: address.streetName,
                                                    name: "corresStreet"
                                                }});
                                        }}
                                        onReset={(setSelectedValue)=>{
                                            setSelectedValue('');
                                            values.corresPostcode = '';
                                            handleChange({ target: {
                                                    type: "change",
                                                    value: '',
                                                    name: "corresStreet"
                                                }});
                                            handleChange({ target: {
                                                    type: "change",
                                                    value: '',
                                                    name: "corresFloor"
                                                }});
                                            handleChange({ target: {
                                                    type: "change",
                                                    value: '',
                                                    name: "corresUnit"
                                                }});
                                            handleChange({ target: {
                                                    type: "change",
                                                    value: '',
                                                    name: "corresBuilding"
                                                }});
                                            setCorrespondingAddress(false)
                                        }}
                                        showDetail={setCorrespondingAddress}
                                        onChange={(value)=>{
                                            handleChange({ target: {
                                                    type: "change",
                                                    value: value,
                                                    name: "corresPostcode"
                                                }});
                                        }}
                                        onClick={(address, setSelectedValue) => {
                                            setSelectedValue(address.postCode);
                                            values.corresPostcode = address.postCode;
                                            handleChange({ target: {
                                                type: "change",
                                                value: address.streetName,
                                                name: "corresStreet"
                                            }});
                                        }}
                                    />
                                </div>
                            </div>
                            {
                                showCorrespondingAddress&&
                                    <>
                                        <div className="UenInputGroupStyle">
                                            <div className="UenInputBoxStyle Caps">
                                                <Field
                                                    label="Street"
                                                    name="corresStreet"
                                                    as={FormTextField}
                                                    errorMessage={touched.corresStreet && errors.corresStreet ? errors.corresStreet : ''}
                                                />
                                            </div>
                                        </div>
                                        <div className="UenInputGroupStyle FloorUnit">
                                            <div className="UenInputBoxStyle">
                                                <div className="FloorUnitContainer">
                                                    <div className={"FloorUnitHashSign"}>#</div>
                                                    <div className="UenInputGroupStyle">
                                                        <div className="UenInputBoxStyle Caps">
                                                            <Field
                                                                label="Floor"
                                                                name="corresFloor"
                                                                as={FormTextField}
                                                                errorMessage={touched.corresFloor && errors.corresFloor ? errors.corresFloor : ''}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className={"FloorUnitDashSign"}> - </div>
                                                    <div className="UenInputGroupStyle">
                                                        <div className="UenInputBoxStyle Caps">
                                                            <Field
                                                                label="Unit"
                                                                name="corresUnit"
                                                                as={FormTextField}
                                                                errorMessage={touched.corresUnit && errors.corresUnit ? errors.corresUnit : ''}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="UenInputGroupStyle">
                                            <div className="UenInputBoxStyle Caps">
                                                <Field
                                                    label="Building"
                                                    name="corresBuilding"
                                                    as={FormTextField}
                                                    errorMessage={touched.corresBuilding && errors.corresBuilding ? errors.corresBuilding : ''}
                                                />
                                            </div>
                                        </div>
                                    </>
                            }
                        </div>
                        }
                        <div className="QuoteUenSubTitleGroupStyle">
                            <div className="QuoteUenSubTitleStyle">Personal Accident Insured Person</div>
                        </div>
                        <div className="UenInputGroupsStyle"  ref={bottomCompRef}>
                            <div className="UenInputGroupStyle">
                                <div className="UenInputBoxStyle Caps">
                                    <Field
                                        label="Name of Insured"
                                        name="insuredName"
                                        as={FormTextField}
                                        errorMessage={touched.insuredName && errors.insuredName ? errors.insuredName :''}
                                    />
                                </div>
                            </div>
                            <div className="UenInputGroupStyle">
                                <div className="UenInputBoxStyle">
                                    <Field
                                        label="Date of Birth"
                                        name="dob" 
                                        as={FormDateField}
                                        errorMessage={errors.dob ? errors.dob :''}
                                        maxDate={moment().add("year", -18)}
                                        minDate={moment().add("year", -65)}
                                        onBlur={(event) => {
                                            if(!event.target.value){
                                                handleChange({ target: {
                                                    type: "change",
                                                    value: initialValues.dob,
                                                    name: "dob"
                                                }});
                                            } else {
                                                handleBlur(event)
                                            }
                                        }}
                                        onChange={(date) => {
                                            handleChange({ target: {
                                                type: "change",
                                                value: date,
                                                name: "dob"
                                            }});
                                        }}
                                    />
                                </div> 
                            </div>
                        </div>
                        <div className="UenInputButtonsGroupStyle">
                            <div className="UenInputBoxStyle">
                                <Button color="primary" type="submit">Continue</Button>
                            </div>
                            {
                                values.uenAvailable ==="verified"?(<div className="UenBufferStyle"/>):''
                            }
                        </div>
                        </React.Fragment>
                        )}
                        </div>
                    </Form>
                )}
            </Formik>
        </Template>
    );

}


// get status from redux (subscription)
const mapStateToProps = (state) => {
    const policy = _getPolicy(state);
    return {
        // this properties will be accessible through props.  e.g. props.size
        policy: policy,
        step: _getStep(state),
        site: _getSite(state)
    }
}

// send service request to redux
const mapDispatchToProps = {
    storePolicy: _storePolicy,
    showSpinner: _showSpinner,
    hideSpinner: _hideSpinner,
    showModal: _showModal,
    hideModal: _hideModal,
    setStep: _setStep,
    saveForLater: _saveForLater
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Uen));
